import { LabeledCardNumber } from '../../modules/labeled-card-number';
import * as donationAmounts from './donation-amounts'
import { customAmountInput } from './donation-amounts';
import './membership-level-groups';

// Mark donor name as disabled if the 'anonymous' checkbox is checked
const anonymousCheckbox = document.querySelector('input[type="checkbox"][data-anonymous-checkbox]') as HTMLInputElement;
const submitButtonDollarAmt = document.querySelector('[data-total-amount]') as HTMLButtonElement;
const donorNameField = document.querySelector('[data-donor-name]') as HTMLInputElement;

anonymousCheckbox?.addEventListener('change', () => {
    if ((anonymousCheckbox).checked) {
        donorNameField.setAttribute('disabled', 'disabled');
        donorNameField.value = '';
    }
    else {
        donorNameField.removeAttribute('disabled');
    }
});

document.addEventListener('DOMContentLoaded', function (event) {
    const membershipErrorField = document.querySelector(".validation-summary-errors") as HTMLElement;
    if (membershipErrorField) {
        document.querySelector(".validation-summary-errors").scrollIntoView({ behavior: 'smooth' });
    }

    const initialCustomAmount = parseInt(customAmountInput.value);
    if (initialCustomAmount) {
        selectMembershipLevelSlide(initialCustomAmount);
    }
});

donationAmounts.initializeAmounts(function (amt: number) {
    // assuming we only take whole numbers dollar donations
    amt = Math.trunc(amt);
    updateSubmitButton(amt);
});


// if page has radio options for changing the frequency of contributions, and the panels which contain those different dollar amounts
// then we associate each radio option with its corresponding panel of donation amounts
// in order for the user to switch between them

const donationFrequencyRadioOptions = Array.from(document.querySelectorAll('[data-radio-panel-to-toggle]'));
const donationAmountPanels: [string, Element][] = Array.from(document.querySelectorAll('[data-radio-panel]')).map(el => [el.getAttribute('data-radio-panel'), el]);
let donationFrequency = '';

if (donationFrequencyRadioOptions?.length > 0 && donationAmountPanels?.length > 0) {
    const frequencyRadioHasMatchingId = (radio, id) => radio.getAttribute('data-radio-panel-to-toggle').split('_')[1] == id;
    for (let panel of donationAmountPanels) {
        const panelId = panel[0].split('_')[1];
        const radioOption = donationFrequencyRadioOptions.filter(frequencyRadio => frequencyRadioHasMatchingId(frequencyRadio, panelId))[0];
        if (radioOption) {
            radioOption.addEventListener('click', () => {
                donationAmountPanels.map(panelTuple => panelTuple[1]).forEach(panel => panel.classList.add('hide'));
                updateFrequency(radioOption.getAttribute('data-frequency'));
                panel[1].classList.remove('hide');
            });
        }
    }
}

function updateSubmitButton(amount: number) {
    submitButtonDollarAmt.innerHTML = (amount > 0) ? ` $${amount} ${donationFrequency ? donationFrequency : ''}` : '';
}

function updateFrequency(frequency: string) {
    donationFrequency = frequency;
}

function updateCustomAmountTextField(amount: number) {
    customAmountInput.value = amount.toString();
}

function changeDonationAmount(amount: number) {
    updateSubmitButton(amount);
    updateCustomAmountTextField(amount);
}

class MembershipLevelGallerySlide {
    slideElement: HTMLElement;
    radioElement: HTMLInputElement;
    donationAmount: number;

    constructor(slideElement, radioElement, donationAmount) {
        this.slideElement = slideElement;
        this.radioElement = radioElement;
        this.donationAmount = donationAmount;

        this.initializeEventListeners();
    }

    initializeEventListeners() {
        this.radioElement.addEventListener('click', (event) => {
            changeDonationAmount(this.donationAmount);
        })

        // radio button on slide handles the donation amount that gets submitted in the form
        this.slideElement.addEventListener('click', (event) => {
            this.select();
        })
    }

    select() {
        membershipLevelGallerySlides.forEach(slide => slide.deselect());
        this.radioElement.click();
        this.slideElement.classList.add('is-active-slide');
        changeDonationAmount(this.donationAmount);
        if (!document.querySelector(".validation-summary-errors")) {
            document.querySelector('[data-membership-anchor]').scrollIntoView({ behavior: 'smooth' })
        }
    }

    selectWithCustomAmount(customAmount: number) {
        this.select();
        changeDonationAmount(customAmount);
    }

    deselect() {
        this.slideElement.classList.remove('is-active-slide');
        this.radioElement.checked = false;
    }
}

// when a slide is clicked and selected, we update the corresponding input elements to reflect that selected level
const membershipLevelGallerySlideElements = Array.from(document.querySelectorAll('.membership-level-gallery .gallery-slide'));
const membershipLevelGallerySlides: MembershipLevelGallerySlide[] = [];
if (membershipLevelGallerySlideElements?.length > 0) {
    membershipLevelGallerySlideElements.forEach(slide => {
        const slideRadio = (slide as HTMLElement).querySelector('[id^=membership-level-item]') as HTMLInputElement;
        const donationAmount = parseInt(slideRadio.value);

        if (slide && slideRadio && donationAmount > 0) {
            const newSlide = new MembershipLevelGallerySlide(slide, slideRadio, donationAmount);
            membershipLevelGallerySlides.push(newSlide)
        }
    })
}

customAmountInput.addEventListener('blur', (event) => {
    const donationAmount = parseInt((event.target as HTMLInputElement).value);
    selectMembershipLevelSlide(donationAmount);
})

const selectMembershipLevelSlide = (amount: number) => {
    if (membershipLevelGallerySlides?.length > 0) {
        let slideToSelect: MembershipLevelGallerySlide = null;
        for (let slide of membershipLevelGallerySlides) {
            if (amount >= slide.donationAmount)
                slideToSelect = slide;
        }

        if (slideToSelect != null) {
            slideToSelect.selectWithCustomAmount(amount);
        } else {
            membershipLevelGallerySlides.forEach(slide => slide.deselect());
        }
    }
}

const cardNumberFormItem = document.querySelector('[data-labeled-card-number]') as HTMLElement;
if (cardNumberFormItem) {
    new LabeledCardNumber(cardNumberFormItem);
}